import { Button } from "@ui-kit/Button";
import { tui } from "../locale";
import { useCanReload } from "../store/useCanReload";
import { useWorkspaceToolsActions } from "../store/useWorkspaceToolsActions";
import { useEnabledToolsState } from "../store/useWorkspaceToolsStore";

export const ToolsUnavailable = ({ reason }: { reason: "failed" | "absent" }) => {
	const canReload = useCanReload();
	const { reload } = useWorkspaceToolsActions();
	const message = useFailureMessage(reason);

	return (
		<div
			className="flex flex-col items-start gap-2 px-1 py-4 text-sm text-muted"
			data-testid="workspace-tools-unavailable"
		>
			{tui(`unavailable.${reason}`)}
			{message && <span className="text-xs">{message}</span>}
			{canReload && (
				<Button onClick={() => void reload()} size="sm" variant="outline">
					{tui("reload")}
				</Button>
			)}
		</div>
	);
};

export const useFailureMessage = (reason: "failed" | "absent"): string | null => {
	const state = useEnabledToolsState();
	return reason === "failed" ? (state?.error?.message ?? null) : null;
};
